import React from 'react';
import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material';

interface Props {
  prompt?: string;

  groups: any[];
  selectedGroup: any;
  onSelectGroup: (group: string | null) => void;
}

export default function GroupSelect({ prompt, groups, selectedGroup, onSelectGroup }: Props) {
  return (
    <form autoComplete="off">
      <FormControl sx={{ width: '100%', mb: 1 }}>
        <Select
          sx={{ textAlign: 'left' }}
          displayEmpty
          name="Groups"
          value={selectedGroup || ''}
          onChange={(event) => onSelectGroup(event.target.value !== '' ? (event.target.value as string) : null)}
        >
          <MenuItem value="" key="" disabled={prompt != null}>
            {prompt || 'All Templates'}
          </MenuItem>

          {groups.map((groupName: any) => (
            <MenuItem value={groupName} key={groupName}>
              {groupName}
            </MenuItem>
          ))}
        </Select>

        <FormHelperText>Select Template Group</FormHelperText>
      </FormControl>
    </form>
  );
}
